const TYPE_PROPERTY = 'Type';

function reorderTypeFirst(value: unknown): unknown {
	if (Array.isArray(value)) {
		return value.map(reorderTypeFirst);
	}
	if (value !== null && typeof value === 'object') {
		const obj = value as Record<string, unknown>;
		const reordered: Record<string, unknown> = {};

		// Place 'Type' first if it exists
		if (Object.prototype.hasOwnProperty.call(obj, TYPE_PROPERTY)) {
			reordered[TYPE_PROPERTY] = reorderTypeFirst(obj[TYPE_PROPERTY]);
		}

		// Add remaining properties, skipping null and undefined values
		for (const key of Object.keys(obj)) {
			if (key !== TYPE_PROPERTY) {
				const processed = reorderTypeFirst(obj[key]);
				if (processed !== null && processed !== undefined) {
					reordered[key] = processed;
				}
			}
		}

		return reordered;
	}
	return value;
}

/** Serializes any object to JSON with the `Type` property placed first on every nested object. */
export function serializeWithTypeFirst(value: unknown, indent?: number): string {
	return JSON.stringify(reorderTypeFirst(value), null, indent);
}
